import React from "react";
import {action_order, apiURL, CORSSupport, userID, userLogin, userPassword} from "../configurationConstant";
import MuiAccordion from "@material-ui/core/Accordion/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {withStyles} from "@material-ui/core";
import {Link} from "react-router-dom";
import {getStatus, PrependZeros} from "../Components/OrderItem";
import {ResultInfo} from "./CartPage";
import {code} from "../Components/CatalogItem";

const Accordion = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        marginBottom: 11,
        padding: 0,
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
            marginBottom: 8,
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        background: '#EBF1F0',
        borderBottom: 'none',
        minHeight: 68,
        '&$expanded': {
            minHeight: 68,
        },
    },
    content: {
        margin: 0,
        '&$expanded': {
            margin: 0,
        },
    },
    expanded: {},
    expandIcon: {
        display: 'inline-block'
    }
})(MuiAccordionSummary);

const AccordionDetails = withStyles(() => ({
    root: {
        padding: '0 15px',
        marginBottom: 8
    },
}))(MuiAccordionDetails);

export class OrderIDPage extends React.Component{

    constructor(props){
        super(props);
        this.handleChangeField = this.handleChangeField.bind(this);
        this.getOrderValue = this.getOrderValue.bind(this);
        this.state ={
            price: 0,
            loaded: false,
            refund: 0,
            result_json_cart: ''
        };
    }

    componentDidMount(): void {
        this.getOrderValue()

    }


    handleChangeField = (panel) => (event, newExpanded) => {
        newExpanded ?this.setState({expanded: panel,close: panel}): this.setState({expanded: false,close: false})
    };

    getOrderValue(){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_order + '&contract=1&log=' + userLogin + '&pwd=' + userPassword +
                '&user=' + userID + '&order=' + this.props.match.params.id ,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200)
                return r.json().then((data) => {
                    let price = 0;
                    let positions = 0;
                    let refund = 0;
                    let result_json = '';
                    try{
                        data.details.forEach(function (details) {
                            refund += Number(details.count);
                            details.services[details.catalogid].forEach(item => {
                                price += Number(item.count_order) * Number(item.order_price);
                                positions+= Number(item.count_order)
                            });
                        });
                        data.details.map((item) =>{
                            let price_item = 0;
                            let count = 0;
                            let service_list =[];
                            item.services[item.catalogid].forEach(el =>{
                                count += Number(el.count_order);
                                price_item += Number(el.order_price) * Number(el.count_order);
                                if (el !== undefined)
                                    service_list.push({"id": Number(item.catalogid),"count": Number(el.count_order), "price":el.order_price});
                            });
                            result_json += JSON.stringify({"id": Number(item.catalogid), "services": service_list, "price": price_item, "refund": Number(item.count)}) + ';';
                        })
                    }catch (e) {
                        data.details =[];
                    }
                    this.setState({
                        loaded: true,
                        item: data,
                        status: getStep(data.status),
                        price: price,
                        positions: positions,
                        refund: refund,
                        result_json_cart: result_json
                    })
                })
        }).catch(r => console.log(r));
    }

    render(){
        return(
            <main id={'order_id_page'}>
                <div>
                    <div className={"title_container"}>
                        <p>Заявка</p>
                    </div>
                    {this.state.loaded ? (
                        <div>
                            <OrderStatus status={this.state.status.status}/>
                            <div className={"title_container"}>
                                <p>{this.state.status.name}</p>
                                <div className={'result_line'}/>
                            </div>
                            <div id={'order_content'}>
                                <div id={'order_content_list'}>
                                    <div id={'order_desktop_number'}>
                                        <p>Заявка №{PrependZeros(Number(this.state.item.number),5)}</p>
                                        <div className={"status "  + getStatus(this.state.item.status).status}>{getStatus(this.state.item.status).name}</div>
                                    </div>
                                    <div id={'order_desktop_table'} className={'order_position_desktop'}>
                                        {['Артикул', 'Название', 'Цена за ед. ₽', 'Услуг в заявке', 'Цена ₽'].map((data, index)=>(<div key={index}>{data}</div>))}
                                    </div>
                                    {this.state.item.details.map((item) =>{
                                        let price = 0;
                                        let count = 0;
                                        let service_list =[];
                                        item.services[item.catalogid].forEach(el =>{
                                            count += Number(el.count_order);
                                            price += Number(el.order_price) * Number(el.count_order);
                                            service_list.push({"id": el.catalog_service_id,"count":Number(el.count_order), "price":el.order_price});
                                        });
                                        const element = <div>
                                            <div className={'order_qr'} onMouseOver={e =>{
                                                document.getElementById('order_position-'+item.itemid).style.height = document.getElementById('order_qr_description-'+item.itemid).offsetHeight+'px';
                                            }} onMouseOut={e => {
                                                document.getElementById('order_position-'+item.itemid).style.height = 38+'px';
                                            }}
                                            >
                                                {code}
                                            <div className={'order_qr_description'} id={'order_qr_description-'+item.itemid}>
                                                {item.customer_name}
                                            </div>
                                            </div> {item.art}
                                        </div>
                                        return(
                                            <div key={item.itemid}>
                                                <div className={'order_item_desktop'}>
                                                    <OrderPositionDesktop item={[element, item.name, '', count, price.toFixed(2)]} id={item.itemid}/>
                                                    {item.services[item.catalogid].map(position =>{
                                                        return(
                                                            <OrderPositionDesktop item={['', position.service_name, Number(position.order_price), position.count_order, ((position.order_price) * (position.count_order)).toFixed(2)]}/>
                                                        )
                                                    })}
                                                </div>
                                                <Accordion square className={'order_item'}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <div className={'order_item_header'}>
                                                            <div className={'order_item_header_info'} >
                                                                <div>
                                                                    <p>{item.name}</p>
                                                                </div>
                                                                <div>
                                                                    <p>₽ {price.toFixed(2)}</p>
                                                                    <p>{count} шт.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails onChange={this.handleChangeField('panel1')}>
                                                        <div style={{width: '100%', borderBottom: '1px dotted black'}}>
                                                            {item.services[item.catalogid].map(position => {
                                                                return(
                                                                    <div>
                                                                        <div className={"order_description_field"}>
                                                                            <p>{position.service_name}</p>
                                                                            <div className={'order_description_field_info'}>
                                                                                <p>₽ {position.order_price}</p>
                                                                                <p>{position.count_order} {position.service_edizm}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div id={'cart_result'}>
                                    {ResultInfo(this.state.item.details.length, this.state.positions, this.state.price, this.state.refund)}
                                    <div >
                                        <div  className={'order_result_info order_payment'}>
                                            <div className={'result_title'}>
                                                <p>Способ оплаты</p>
                                            </div>
                                            <div className={'result_line'}/>
                                            <div id={'result_account'} className={'result_position '}>
                                                <p>По счету</p>
                                            </div>
                                            <div id={'result_document'}>
                                                <p>Список документов по оплате</p>
                                            </div>
                                            <div id={'order_link_list'}>
                                                <a>Счет на оплату</a>
                                                <a>УПД</a>
                                                <a>Транспортная накладная</a>
                                            </div>
                                            <div className={'result_position'}>
                                                <a>Скачать все</a>
                                            </div>
                                        </div>
                                        <div className={'order_result_info order_payment'}>
                                            <div className={'result_title'}>
                                                <p>Доставка</p>
                                            </div>
                                            <div className={'result_line'}/>
                                            <div className={'result_position'}>
                                                <p>Способ доставки: Курьером</p>
                                            </div>
                                            {this.state.item.order_complete_date !== null? (
                                                <div className={'result_position'}>
                                                    <p>Дата доставки: {this.state.item.order_complete_date.split(" ")[0]}</p>
                                                </div>
                                            ): undefined}
                                            <div className={'result_position'}>
                                                <p>Стоимость доставки: 10 000 руб.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'order_result order_repeat'}>
                                        <Link to={'/cart'}>
                                            <button className={'order_button'} onClick={() => {
                                                localStorage.setItem('cart', this.state.result_json_cart);
                                            }}>
                                                <p>Повторить</p>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ): undefined}
                </div>
            </main>
        )
    }
}

export const OrderStatus = (status) => {
    return(
        <div id={'order_status'}>
            <div className={'order_step'}>
                {['100','200','400','950','1000'].map((item,index)=>{
                    if (status.status > index+1) return (<div className={'finished_step'} key={index}><div><div><div><p className={'order_step_name'}>{getStep(item).name}</p></div></div></div></div>);
                    else if (status.status === index+1) return  (<div className={'now_step'} key={index}><div><div><p className={'order_step_name'}>{getStep(item).name}</p></div></div></div>);
                    else return  (<div className={'next_step'} key={index}><div><div><p className={'order_step_name'}>{getStep(item).name}</p></div></div></div>);
                })}
            </div>
            <svg className={'order_step_line_desktop'}
                 xmlns="http://www.w3.org/2000/svg"
                 xmlnsXlink="http://www.w3.org/1999/xlink"
                 width="846px" height="72px">
                <image  x="0px" y="0px" width="846px" height="72px"  xlinkHref="data:img/png;base64,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" />
            </svg>
            <div className={'order_step_line'}/>
        </div>
    )
};

export const OrderPositionDesktop = (item) =>{
    return(
        <div className={'order_position_desktop'} id={item.id !== undefined ? 'order_position-'+item.id: ''}>
            {item.item.map((data, index)=>(<div key={index}>{data}</div>))}
        </div>
    )
};

export function getStep(value){
    let answer = {name: '', status:''};
    switch (value) {
        case '100':
        case '150':
            answer.name = 'Создание';
            answer.status = 1;
            break;
        case '200':
        case '250':
            answer.name = 'Обработка';
            answer.status = 2;
            break;
        case '400':
        case '450':
        case '500':
        case '600':
        case '700':
        case '800':
        case '900':
            answer.name = 'Выполнение';
            answer.status = 3;
            break;
        case '950':
        case '960':
            answer.name = 'Оплата';
            answer.status = 4;
            break;
        case '1000':
        case '10000':
            answer.name = 'Завершена';
            answer.status = 5;
            break;
        default:
            answer.name = 'Создание';
            answer.status = 1;
            break;
    }
    return answer;
}
